// Ported from cartadigital-pos app/utils/order-auto-close-baseline.ts —
// adapted to admin's server ids (number) instead of localId strings.
export interface IOrderAutoCloseBaselineState {
  armedForOrderId: number | null;
  initialIsArchived: boolean;
  initialIsCanceled: boolean;
}

export interface IOrderAutoCloseBaselineInput {
  orderId: number | null;
  /**
   * Whether we have enough data loaded to treat `isArchived`/`isCanceled` as a
   * stable baseline for this order view.
   */
  isReady: boolean;
  isArchived: boolean;
  isCanceled: boolean;
}

export function getInitialOrderAutoCloseBaselineState(): IOrderAutoCloseBaselineState {
  return {
    armedForOrderId: null,
    initialIsArchived: false,
    initialIsCanceled: false,
  };
}

export function computeNextOrderAutoCloseBaselineState(
  prev: IOrderAutoCloseBaselineState,
  input: IOrderAutoCloseBaselineInput
): IOrderAutoCloseBaselineState {
  if (!input.orderId || !input.isReady) {
    return getInitialOrderAutoCloseBaselineState();
  }

  // Once armed for a given order, the baseline must remain immutable for that view.
  if (prev.armedForOrderId === input.orderId) {
    return prev;
  }

  return {
    armedForOrderId: input.orderId,
    initialIsArchived: input.isArchived,
    initialIsCanceled: input.isCanceled,
  };
}

export function shouldAutoCloseArchivedTransition(input: {
  state: IOrderAutoCloseBaselineState;
  orderId: number | null;
  next: boolean;
  prev: boolean;
}): boolean {
  if (!input.next || input.prev) return false;
  if (!input.orderId) return false;
  if (input.state.armedForOrderId !== input.orderId) return false;
  if (input.state.initialIsArchived) return false;
  return true;
}

export function shouldAutoCloseCanceledTransition(input: {
  state: IOrderAutoCloseBaselineState;
  orderId: number | null;
  next: boolean;
  prev: boolean;
}): boolean {
  if (!input.next || input.prev) return false;
  if (!input.orderId) return false;
  if (input.state.armedForOrderId !== input.orderId) return false;
  if (input.state.initialIsCanceled) return false;
  return true;
}
